import { ZealApiResponse, Shift, IEmployeeCheck } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export interface IGenerateAccrualPreviewsRequestBody {
  checksWithShifts: {
    check: IEmployeeCheck;
    shifts: Shift[];
  }[];
  companyID: string;
  testMode: boolean;
}

export interface IAccrualPreview {
  policyID: string;
  policyType: string;
  policyCode: string;
  policyName: string;
  accrued: number;
  usage?: number;
  balance: number;
}

export interface IAccrualPreviewsByCheckID {
  [checkID: string]: {
    checkID: string;
    accruals: IAccrualPreview[];
  };
}

export const generateAccrualPreviews = (axios: IAxiosInstance) => {
  return async (body: IGenerateAccrualPreviewsRequestBody) => {
    const response = await axios.with502Retry.post<
      ZealApiResponse<IAccrualPreviewsByCheckID>
    >(`/api/picard/generate-accrual-previews`, body, {});

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
